import React, { useEffect, useRef, useState } from "react";

const InputDate = ({
  name,
  value = "",
  onChange,
  placeholder,
  validateFutureDate = true,
  required,
  min,
}) => {
  const [errMsg, setErrMsg] = useState("");
  const [inputValue, setInputValue] = useState("");

  const datePickerRef = useRef(null);

  // Convert yyyy-mm-dd -> dd-mm-yyyy
  const formatDateForDisplay = (date) => {
    if (!date) return "";

    const [year, month, day] = date.split("-");

    if (!year || !month || !day) return "";

    return `${day}-${month}-${year}`;
  };

  // Convert dd-mm-yyyy -> yyyy-mm-dd
  const formatDateForValue = (date) => {
    const parts = date.split("-");

    if (parts.length !== 3) return "";

    const [day, month, year] = parts;

    if (
      day.length !== 2 ||
      month.length !== 2 ||
      year.length !== 4
    ) {
      return "";
    }

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    setInputValue(formatDateForDisplay(value));
  }, [value]);


const handleManualChange = (e) => {
  let typedValue = e.target.value;

  // Allow only numbers and hyphens
  typedValue = typedValue.replace(/[^\d-]/g, "");

  // Limit input length
  typedValue = typedValue.slice(0, 10);

  // Allow the user to clear the input completely
  setInputValue(typedValue);

  // Clear parent value when input is empty
  if (!typedValue) {
    onChange({
      target: {
        name,
        value: "",
      },
    });
    setErrMsg("");
    return;
  }

  // Update parent only when date is complete
  if (typedValue.length === 10) {
    const formattedDate = formatDateForValue(typedValue);

    if (formattedDate) {
      onChange({
        target: {
          name,
          value: formattedDate,
        },
      });
    }
  }
};

  const handleCalendarChange = (e) => {
    const selectedValue = e.target.value;

    setInputValue(formatDateForDisplay(selectedValue));

    onChange({
      target: {
        name,
        value: selectedValue,
      },
    });
  };


const handleBlur = () => {
  if (!inputValue.trim()) {
    if (required) {
      setErrMsg("Date is required.");
    } else {
      setErrMsg("");
    }
    return;
  }

  const parts = inputValue.split("-");

  if (parts.length !== 3) {
    setErrMsg("Please enter date in DD-MM-YYYY format.");
    return;
  }

  const [day, month, year] = parts;

  if (
    !day ||
    !month ||
    year.length !== 4 ||
    day.length > 2 ||
    month.length > 2 ||
    day.length < 1 ||
    month.length < 1
  ) {
    setErrMsg("Please enter date in DD-MM-YYYY format.");
    return;
  }

  const formattedDate =
    `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

  const selectedDate = new Date(`${formattedDate}T00:00:00`);

  // Check whether the date actually exists
  if (
    isNaN(selectedDate.getTime()) ||
    selectedDate.getFullYear() !== Number(year) ||
    selectedDate.getMonth() + 1 !== Number(month) ||
    selectedDate.getDate() !== Number(day)
  ) {
    setErrMsg("Please enter a valid date.");
    return;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (validateFutureDate && selectedDate < today) {
    setErrMsg("Please select today's date or a future date.");
    return;
  }

  setInputValue(
    `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`
  );

  onChange({
    target: {
      name,
      value: formattedDate,
    },
  });

  setErrMsg("");
};

  const openCalendar = () => {
    if (datePickerRef.current?.showPicker) {
      datePickerRef.current.showPicker();
    } else {
      datePickerRef.current?.focus();
    }
  };

  return (
    <>
      <div className="form-group position-relative">
        <label htmlFor={name} className="col-form-label">
          {placeholder}
          {required && <span className="text-danger">*</span>}
        </label>

        <div className="position-relative">
          {/* Manual input */}
          <input
            type="text"
            className="form-control"
            name={name}
            value={inputValue}
            onChange={handleManualChange}
            onBlur={handleBlur}
            placeholder="DD-MM-YYYY"
            required={required || false}
            maxLength={10}
          />

          {/* Calendar button */}
          <button
            type="button"
            onClick={openCalendar}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            📅
          </button>

          {/* Hidden native calendar */}
          <input
            ref={datePickerRef}
            type="date"
            value={value || ""}
            onChange={handleCalendarChange}
            min={min}
            tabIndex="-1"
            style={{
              position: "absolute",
              width: "1px",
              height: "1px",
              opacity: 0,
              pointerEvents: "none",
            }}
          />
        </div>

        {required && errMsg && (
          <small className="text-danger">{errMsg}</small>
        )}
      </div>
    </>
  );
};

export default InputDate;